export const VERIFICATION_CODE_LENGTH = 6;
export const RESEND_CODE_ERROR_TYPE = 'resend_code_required';
export const INCORRECT_CODE_ERROR_TYPE = 'incorrect_code';
export const INCORRECT_CODE_ERROR_MESSAGE = 'Incorrect code, please try again.';
export const RESEND_CODE_ERROR_MESSAGE =
  'Please try a new code using the "Resend Code" button below.';
export const TOO_MANY_ATTEMPTS_MESSAGE =
  'Too many attempts. Please refresh the page and try again.';
